import * as React from "react";
import * as ReactDOM from "react-dom";
import { withRouter, WithRouterProps, Link } from "react-router";
/* tslint:disable */
import { Title, Space, Text } from "@root/shared";
/* tslint:enable */
import { Color, IconName, Size, Paragraph, TextColor, IconSize, Icon } from "@root/shared";
import { LoginShellFull } from "./login-shell-full";
import { ErrorBlock } from "@root/shared";
import * as UTMCookie from "@root/shared/utils/utm-cookie";
import { locationStore } from "../stores/location-store";
import { ILinkItem } from "./link-item";
import { observer } from "mobx-react";
import { SignupProps } from "@lib/common-interfaces";
import { LoginUrlHelper, ReturnUrls } from "./utils/login-url-helper";
import { LoginButtons } from "./login-buttons/login-buttons";
import { hasConsent } from "../lib/utils/cookie-consent";
import { AppInvitationCard } from "client/login/app-invitation-card/app-invitation-card";

const styles = require("./login.scss");

@withRouter
@observer
export class Signup extends React.Component<WithRouterProps, {}> {
  public initProps: SignupProps;

  constructor(props: WithRouterProps, state: any) {
    super(props, state);
  }

  private _form: any;

  public onSubmit(form: any, e: any) {
    (ReactDOM.findDOMNode(this._form) as any).submit();
  }

  public showErrorMessage(message: string) {
    return <ErrorBlock>{message}</ErrorBlock>;
  }

  public UNSAFE_componentWillMount() {
    // Initialize the locationStore
    locationStore.setRouter(this.props.router);
    // Get initProps
    const { initProps = {} } = window as any;
    this.initProps = initProps;

    // Set a cookie with any UTM params so we can sync them to Intercom after account creation.
    // (Intercom syncing is done in shell.tsx.)
    if (hasConsent()) {
      UTMCookie.write();
    }
  }

  public componentWillUnmount() {
    this.initProps.message = null;
    this.initProps.email = null;
  }

  public render() {
    const myWindow = window as any,
      currLocation = myWindow.location || {},
      returnUrls: ReturnUrls = LoginUrlHelper.buildReturnUrls(currLocation.search, this.initProps),
      bottomLinks: ILinkItem[] = [
        {
          route: "https://azure.microsoft.com/en-us/support/legal/",
          title: "Terms of use"
        }
      ],
      externalBottomLinks: ILinkItem[] = [
        {
          route: "https://aka.ms/appcenterprivacy",
          title: "Privacy"
        },
        {
          route: "https://status.appcenter.ms/",
          title: "Status"
        }
      ];

    const { appInvitation, organizationInvitation } = this.initProps;
    const titleArea = (() => {
      if (appInvitation) {
        return (
          <>
            <AppInvitationCard {...appInvitation} />
            <Title className={styles.createAccountInvitation} spaceAbove={Space.Medium} size={Size.Small}>
              Create Account
            </Title>
          </>
        );
      } else if (organizationInvitation) {
        return (
          <Title size={Size.Small}>
            {organizationInvitation.inviterName} invited you to join {organizationInvitation.organizationDisplayName}.
          </Title>
        );
      } else {
        return <Title size={Size.Small}>Create Account</Title>;
      }
    })();

    return (
      <LoginShellFull linkItems={bottomLinks} externalLinkItems={externalBottomLinks} titleArea={titleArea} attemptingSignup={true}>
        <div>
          <LoginButtons />
          <Text size={Size.Small}>
            By creating an account you accept our
            <br />
            <a target="_blank" href="https://azure.microsoft.com/en-us/support/legal/">
              Terms of use
            </a>{" "}
            and{" "}
            <a target="_blank" href="https://aka.ms/appcenterprivacy">
              Privacy policy
            </a>
            .
          </Text>
        </div>
        <div className={styles["account-action-wrapper"]}>
          <Link className={styles["account-action"]} to={"/sign-in" + returnUrls.original}>
            <Paragraph color={TextColor.Link} size={Size.Medium} className={styles["account-action-link-wrapper"]}>
              I already have an account <Icon color={Color.Blue} size={IconSize.Small} icon={IconName.ButtonChevronRight} />
            </Paragraph>
          </Link>
        </div>
      </LoginShellFull>
    );
  }
}
